export const SET_PROSPECTIVE_STUDENTS_QUERY = 'SET_PROSPECTIVE_STUDENTS_QUERY';
export const SET_PARENTS_OF_PROSPECTS_QUERY = 'SET_PARENTS_OF_PROSPECTS_QUERY';
export const SET_OTHER_QUERY = 'SET_OTHER_QUERY';
export const SET_USA_QUERY = 'SET_USA_QUERY';
export const SET_INTERNATIONAL_QUERY = 'SET_INTERNATIONAL_QUERY';
export const SET_AGE_QUERY = 'SET_AGE_QUERY';
export const SET_GENDER_QUERY = 'SET_GENDER_QUERY';
export const SET_ETHNICITY_QUERY = 'SET_ETHNICITY_QUERY';
export const SET_INTENDED_LEVEL_OF_STUDY_QUERY =
  'SET_INTENDED_LEVEL_OF_STUDY_QUERY';
export const SET_ENTRY_TERM_QUERY = 'SET_ENTRY_TERM_QUERY';
export const SET_INTENDED_MAJOR_QUERY = 'SET_INTENDED_MAJOR_QUERY';
export const SET_GPA_QUERY = 'SET_GPA_QUERY';
export const SET_TEST_SCORES_QUERY = 'SET_TEST_SCORES_QUERY';
export const SET_DATE_REGISTERED_QUERY = 'SET_DATE_REGISTERED_QUERY';
export const SET_RELATIVE_ENGAGEMENT_QUERY = 'SET_RELATIVE_ENGAGEMENT_QUERY';
export const SET_TOTAL_TIME_SPENT_QUERY = 'SET_TOTAL_TIME_SPENT_QUERY';
export const SET_SCHEDULED_VISIT_QUERY = 'SET_SCHEDULED_VISIT_QUERY';
export const SET_APPLIED_QUERY = 'SET_APPLIED_QUERY';
export const SET_ACTIVITY_WITH_INSTITUTION_QUERY =
  'SET_ACTIVITY_WITH_INSTITUTION_QUERY';
export const SET_ACTIVITY_WITH_EAB_QUERY = 'SET_ACTIVITY_WITH_EAB_QUERY';
export const SET_LIST_MEMBERSHIP_QUERY = 'SET_LIST_MEMBERSHIP_QUERY';
export const SET_LOCATIONS_QUERY = 'SET_LOCATIONS_QUERY';
export const SET_QUERY_IS_INCONGRUENT = 'SET_QUERY_IS_INCONGRUENT';
